module.exports = __webpack_public_path__ + "static/assets/6549b78c84871c6c4e8b293e9435cde6.gif";